// import gsap from "gsap"
// import ScrollTrigger from "gsap/ScrollTrigger"

// gsap.registerPlugin(ScrollTrigger)

export default class {
  constructor(el, options) {
    try {
      const elements = Array.from(el.querySelectorAll(".js-reveal"))
      const observer = new IntersectionObserver(handleIntersection)

      const callback = (el) => {
        const itemData = el.dataset

        el.animate(
          [
            {
              opacity: itemData.opacity ? Number(itemData.opacity) : 0,
              transform: `translate3d(${
                itemData.px
                  ? itemData.px + "%"
                  : itemData.x
                  ? itemData.x + "px"
                  : "0%"
              }, ${
                itemData.py
                  ? itemData.py + "%"
                  : itemData.y
                  ? itemData.y + "px"
                  : "0%"
              }, 0) scale(${itemData.scale ? itemData.scale : 1})`,
            },
            // { opacity: 0.75 },
            { opacity: 1, transform: "translate3d(0, 0, 0) scale(1)" },
          ],
          {
            duration: itemData.duration
              ? Number(itemData.duration) * 1000
              : 600,
            delay: itemData.delay ? Number(itemData.delay) * 1000 : 0,
            easing:
              itemData?.easing && itemData?.easing === "bounce"
                ? "cubic-bezier(.47,1.64,.41,.8)"
                : "ease-in-out",
            fill: "forwards",
          },
        )
      }

      elements.forEach((el) => {
        // TODO Trigger settings
        el.style.opacity = "0"

        observer.observe(el, {
          threshold: 0.45,
        })
      })

      function handleIntersection(entries, observer) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            callback(entry.target)
            observer.unobserve(entry.target)
          }
        })
      }
    } catch (err) {
      console.error(err)
      if (elements) {
        elements.forEach((el) => {
          el.style.opacity = 1
        })
      }
    }
  }
}
